Events = require("ampersand-events")

window.EventBus ?= Events.createEmitter()

module.exports = EventBus
